import React from "react";
import ReactApexChart from "react-apexcharts";

class ProjectAchievementChart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: "نسبة الإنجاز",
          data: [],
        },
      ],
      options: {
        chart: {
          type: "bar",
          height: 350,
          toolbar: { show: false },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "60%",
            endingShape: "rounded",
          },
        },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${val}%`,
          style: {
            fontSize: "12px",
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: "رمز المشروع",
            style: {
              fontSize: "14px",
              fontFamily: "Cairo",
            },
          },
        },
        yaxis: {
          labels: {
            formatter: (val) => `${val}%`,
          },
          max: 100,
        },
        colors: ["#28a745"],
        tooltip: {
          y: {
            formatter: (val) => `${val}%`,
          },
        },
      },
    };
  }



  render() {
    return (
      <div className="card mt-4 p-3">
        <ReactApexChart
          options={this.state.options}
          series={this.state.series}
          type="bar"
          height={350}
        />
      </div>
    );
  }
}

export default ProjectAchievementChart;
